export default __webpack_public_path__ + "static/media/prezencne-pk-5-banner-graphics.78a8e7a2.svg";